import {createElement, createButton, htmlStringToElement} from './utils_element';
import {abortableAppRequest, appQuery, appRequest} from './utils_request';
import {initCollection} from './form_collection'

const idCollectionDrafts = 'adjudication_vehicle_invoiceDrafts';

export const init = () => {
    let formPVElements = document.querySelectorAll('form[name=adjudication_vehicle]');
    initCollection(idCollectionDrafts);
    initSearchBusinessPartner(formPVElements[0]);
    initDraftInvoice();
    initBusinessPartnerOpenForm();
    document.getElementById('addItem').addEventListener('click', () => initDraftInvoice());
    document.getElementById('clearForm').addEventListener('click', (e) => {
        e.preventDefault();
        setBusinessPartnerFormData(formPVElements[0], null, true);
    });
    /*
    document.getElementById('reloadBPButton').addEventListener('click', (e) => {
        e.preventDefault();
        reloadBusinessPartner()
    });
    */
};

const initDraftInvoice = () => {
    let draftForm = document.getElementById('adjudication_vehicle_invoiceDrafts');
    Array.from(draftForm.children).forEach((line) => {
        let select = line.firstElementChild;

        if (!select) return;
        initDraftSelectChange(select, line);

        let itemCode = select.value;

        if (itemCode !== 'TRANSPORT') {
            Array.from(line.children).forEach((input) => {
                if (input.id.includes('prixDAchat')) {
                    prixDAchatAble(input,false);
                }
            });
        }
        Array.from(line.children).forEach((input) => {

            if(input.id.includes('quantite')) {
                if(input.value == ''){
                    input.value = 1;
                }
            }
        });
    });
};

const initDraftSelectChange = (select, line) => {
    select.addEventListener('change', (e) => {
        let value = e.currentTarget.value;
        Array.from(line.children).forEach((input) => {
            if (input.id.includes('libelleItem')) {
                input.value = itemsName[value];
            }
            if (input.id.includes('prixDAchat')) {
                if (value === 'TRANSPORT') {
                    prixDAchatAble(input);
                } else {
                    prixDAchatAble(input, false);
                }
            }
        });
    });
};

const prixDAchatAble = (input, able = true) => {
    input.disabled = !able;
    input.value = able ? 0 : null;
};

const initSubmitSearch = (formPVElements) => {
    document.getElementById('adjudication_vehicle_submit').addEventListener('click', (e) => {
        e.preventDefault();
        let email = document.getElementById('adjudication_vehicle_line_email').value,
            siren = document.getElementById('adjudication_vehicle_line_siren').value,
            siret = document.getElementById('adjudication_vehicle_line_siret').value,
            tvaIntracom = document.getElementById('adjudication_vehicle_line_tvaIntracom').value,
            cardCode = document.getElementById('adjudication_vehicle_line_cardcodeAcheteur').value,
            data = {email, siren, siret, tvaIntracom};
        if (!cardCode && (siren || email || siret || tvaIntracom)) {
            searchBusinessPartnerWithEmail(formPVElements, data);
        } else {
            document.forms['adjudication_vehicle'].submit();
        }
    });
};

const initSearchBusinessPartner = (formPVElements) => {
    let searchElement = document.getElementById('globalSearch');
    let searchSirenElement = document.getElementById('searchSiren');
    initSubmitSearch(formPVElements);

    searchElement.addEventListener('keyup', (e) => {
        e.preventDefault();
        searchBusinessPartner(formPVElements, e, searchElement);
        document.addEventListener('click', checkToRemoveSearchBusinessPartner)
    });
    searchSirenElement.addEventListener('click', (e) => {
        e.preventDefault();
        searchBusinessPartnerWithSiren(formPVElements);
    });
};

const removeSearchBusinessPartner = () => {
    if (document.querySelector(".list-business-partners") !== null) {
        document.querySelector(".list-business-partners").remove();
    }
};

const checkToRemoveSearchBusinessPartner = (e) => {
    if (e.target.className.indexOf('list-group-item-action') === -1) {
        removeSearchBusinessPartner();
    }
    document.removeEventListener('click', checkToRemoveSearchBusinessPartner)
};

const searchBusinessPartner = (formPVElements, event, searchElement) => {
    let data = getBusinessPartnerFormData(formPVElements, searchElement);
    let request = abortableAppRequest(urls.searchBusinessPartner, data);
    request.ready.then((data) => {
        if (typeof data.valid !== "undefined" && !data.valid) {
            // alert('System error : can\'t fetch for business partners.');
        } else {
            removeSearchBusinessPartner();
            addBusinessPartnerResult(data, event, formPVElements);
        }
    });
    document.getElementById('globalSearch').addEventListener('keydown', () => request.abort());
};

const searchBusinessPartnerWithSiren = (formPVElements) => {
    document.getElementById('adjudication_vehicle_line_cardcodeAcheteur').value = '';
    searchLoadingSiren();
    let siren = document.getElementById('adjudication_vehicle_line_siren').value;
    appQuery(urls.searchPartnersWithSiren + '/' + siren)
        .then((data) => {
            searchLoadingSiren(false);
            if (typeof data.valid !== "undefined" && !data.valid) {
                alert('System error : can\'t fetch for business partners.');
            } else {
                if (data.result.sireneApi) {
                    setBusinessPartnerFormData(formPVElements, data.result.sireneApi);
                }
                if (data.result.sapPartner) {
                    askForPartnerFound(formPVElements, data.result.sapPartner);
                }
            }
        });
};

const searchBusinessPartnerWithEmail = (formPVElements, data) => {
    appRequest(urls.searchExistingPartner, data)
        .then((data) => {
            if (typeof data.valid !== "undefined" && !data.valid) {
                alert('System error : can\'t fetch for business partners.');
            } else {
                if (data) {
                    askForPartnerFound(formPVElements, data);
                } else {
                    document.forms['adjudication_vehicle'].submit();
                }
            }
        });
};

const searchLoadingSiren = (searching = true) => {
    let searchSirenIcon = document.getElementById('searchSirenIcon');
    document.getElementById('searchSiren').disabled = searching;
    if (searching) {
        searchSirenIcon.classList.remove('fa-search');
        searchSirenIcon.classList.add('fa-spinner-third');
        searchSirenIcon.classList.add('fa-spin');
    } else {
        searchSirenIcon.classList.add('fa-search');
        searchSirenIcon.classList.remove('fa-spinner-third');
        searchSirenIcon.classList.remove('fa-spin');
    }
};

const askForPartnerFound = (formPVElements, partner) => {
    let partnerName = partner['CardName'];
    document.getElementById('searchSirenSapPartner').innerHTML = partnerName + ' (' + partner.CardCode +')';
    let modal = document.getElementById('searchSirenModal');
    $(modal).modal('show');
    document.getElementById('confirmPartner').addEventListener('click', () =>
        setBusinessPartnerFormData(formPVElements, partner)
    );
    document.getElementById('overturnPartner').addEventListener('click', () => {
        let submitButton = document.getElementById('adjudication_vehicle_submit');
        if(submitButton.classList.contains('d-none')){
            submitButton.classList.remove('d-none');
        }
    });
};

const addBusinessPartnerResult = (result, event, formPVElements) => {
    let targetField = document.getElementById(event.target.id),
        list = createElement('div', 'list-business-partners');

    while (list.firstChild) {
        list.removeChild(list.firstChild);
    }

    result.map((e) => {
        let child = createElement('button', 'list-group-item list-group-item-action'),
            partner = JSON.parse(e);
        child.type = "button";
        child.onclick = (e) => {
            e.preventDefault();
            setBusinessPartnerFormData(formPVElements, partner);
            removeSearchBusinessPartner(e);
            initBusinessPartnerOpenForm();
        };
        child.innerHTML = '<i class="' + partner['BuyIndicator'] + ' mt-1 mr-2"></i>' + '<b>'+ partner['CardCode']+'</b> ' + '<b>' + partner["CardName"] + '</b> (' + partner["FirstName"] + ', '
            + partner["LastName"] + ') - ' + partner['City'] + ' - <i>' + partner['Street'] + '</i>';
        list.appendChild(child);
    });
    targetField.parentNode.appendChild(list);
};

export const reloadBusinessPartner = () => {
    if($($('#reloadBPButton > svg')[0]).hasClass('fa-spin') == false) {
        let cardCode = document.getElementById('adjudication_vehicle_line_cardcodeAcheteur').value;
        if(cardCode == ''){
            return;
        }
        $($('#reloadBPButton > svg')[0]).addClass('fa-spin');
        appQuery(urls.reloadExistingPartner.replace('toRpCardCode',cardCode))
            .then((data) => {
                if(!data.valid){
                    alert(data.error);
                } else {
                    // Update data
                    $("#adjudication_vehicle_line_email").val(data.result['EmailPartenaire']);
                    $("#adjudication_vehicle_line_groupCode").val(data.result['GroupCode']);
                    $("#adjudication_vehicle_line_tel").val(data.result['Phone1']);
                    $("#adjudication_vehicle_line_tvaIntracom").val(data.result['NumTVAIntracom']);
                    $("#adjudication_vehicle_line_siren").val(data.result['Siren']);
                    $("#adjudication_vehicle_line_siret").val(data.result['Siret']);
                    $("#adjudication_vehicle_line_nomEntreprise").val(data.result['CardName']);
                }
                $($('#reloadBPButton > svg')[0]).removeClass('fa-spin');
            });
    }
}

const initBusinessPartnerOpenForm = () => {
    let btn = document.getElementById('openPartner'),
        cardCode = document.getElementById('adjudication_vehicle_line_cardcodeAcheteur').value;

    if (cardCode){
        btn.classList.remove('d-none');
        $(btn).off('click');
        btn.addEventListener('click', () => {
            openForm('OCRD', cardCode);
        });
    }
};

const getBusinessPartnerFormData = (formElements, searchElement) => {
    let data = {};
    data.search = searchElement.value;
    return data;
};

export const openBP = () => {
    if(document.getElementById('adjudication_vehicle_line_cardcodeAcheteur').value != ''){
        openForm('OCRD',document.getElementById('adjudication_vehicle_line_cardcodeAcheteur').value);
    };
}

const setBusinessPartnerFormData = (formElements, partner, clearForm = false) => {
    let CardCode = (partner == null) ? '' : (partner['CardCode'] == null ? '' : partner['CardCode']) ;
    for (let i = 0; i < formElements.length; i++) {
        if (formElements[i].id === "adjudication_vehicle_line_cardcodeAcheteur") {
            formElements[i].value = clearForm ? null : partner['CardCode'];
        } else if (formElements[i].id === "adjudication_vehicle_line_prenomAcheteur") {
            formElements[i].value = clearForm ? null : partner['FirstName'];
        } else if (formElements[i].id === "adjudication_vehicle_line_nomAcheteur") {
            formElements[i].value = clearForm ? null : partner['LastName'];
        } else if (formElements[i].id === "adjudication_vehicle_line_villeAcheteur") {
            formElements[i].value = clearForm ? null : partner['City'];
        } else if (formElements[i].id === "adjudication_vehicle_line_email") {
            formElements[i].value = clearForm ? null : partner['EmailPartenaire'];
            formElements[i].readOnly = CardCode != '';
        } else if (formElements[i].id === "adjudication_vehicle_line_titreAcheteur") {
            formElements[i].value = clearForm ? null : partner['Titre'];
        } else if (formElements[i].id === "adjudication_vehicle_line_franchiseTva") {
            formElements[i].value = clearForm ? "Non" : partner['FranchiseTVA'];
        } else if (formElements[i].id === "adjudication_vehicle_line_consignationTva") {
            formElements[i].value = clearForm ? "Non" : partner['ConsignationTVA'];
        } else if (formElements[i].id === "adjudication_vehicle_line_groupCode") {
            if (partner !== null && partner['GroupCode']){
                formElements[i].value = clearForm ? formElements[i].value : partner['GroupCode'];
            }
            formElements[i].readOnly = CardCode != '';
        } else if (formElements[i].id === "adjudication_vehicle_line_adresse1Acheteur") {
            formElements[i].value = clearForm ? null : partner['Street'];
        } else if (formElements[i].id === "adjudication_vehicle_line_codePostalAcheteur") {
            formElements[i].value = clearForm ? null : partner['ZipCode'];
        } else if (formElements[i].id === "adjudication_vehicle_line_tel") {
            formElements[i].value = clearForm ? null : partner['Phone1'];
            formElements[i].readOnly = CardCode != '';
        } else if (formElements[i].id === "adjudication_vehicle_line_destination") {
            formElements[i].value = clearForm ? "France" : partner['Destination'];
        } else if (formElements[i].id === "adjudication_vehicle_line_tvaIntracom") {
            formElements[i].value = clearForm ? null : partner['NumTVAIntracom'];
            formElements[i].readOnly = CardCode != '';
        } else if (formElements[i].id === "adjudication_vehicle_line_countrycodeAcheteur") {
            formElements[i].value = clearForm ? 'FR' : partner['Country'];
        } else if (formElements[i].id === "adjudication_vehicle_line_nomJeuneFille") {
            formElements[i].value = clearForm ? null : partner['NomJeuneFille'];
        } else if (formElements[i].id === "adjudication_vehicle_line_adresse2Acheteur") {
            formElements[i].value = clearForm ? null : partner['StreetNo'];
        } else if (formElements[i].id === "adjudication_vehicle_line_siren") {
            formElements[i].value = clearForm ? null : partner['Siren'];
            formElements[i].readOnly = CardCode != '';
        } else if (formElements[i].id === "adjudication_vehicle_line_siret") {
            formElements[i].value = clearForm ? null : partner['Siret'];
            formElements[i].readOnly = CardCode != '';
        } else if (formElements[i].id === "adjudication_vehicle_line_nomEntreprise") {
            //if (partner['GroupName'] !== "Particulier"){
                formElements[i].value = clearForm ?
                    null :
                    (partner['GroupName'] !== "Particulier" ? partner['CardName'] : null);
            //}
            formElements[i].readOnly = CardCode != '';
        }
        if(CardCode != ''){
            //if($('#reloadBPButton').hasClass('d-none')){
            //    $('#reloadBPButton').removeClass('d-none');
            //}
        } else {
            //if(!$('#reloadBPButton').hasClass('d-none')){
            //    $('#reloadBPButton').addClass('d-none');
            //}
            if(!$('#openPartner').hasClass('d-none')){
                $('#openPartner').addClass('d-none');
            }
        }
    }
};

export const adjustByCountry = () => {
    let selectedCountry = $('#adjudication_vehicle_line_countrycodeAcheteur > option:selected');
    let destination = selectedCountry.attr('data-destination');

    $('#adjudication_vehicle_line_franchiseTva').val('Non');
    $('#adjudication_vehicle_line_destination').val(destination);
    if(destination === 'Hors CEE'){
        $('#adjudication_vehicle_line_consignationTva').val('Oui');
    } else {
        $('#adjudication_vehicle_line_consignationTva').val('Non');
    }
}







// WEBPACK FOOTER //
// ./assets/js/edit_adjudication_vehicle.js